import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Crown, Skull, Trophy } from "lucide-react";

export default function EndModal({ board, self, onReset, onLeave }) {
  const winner = board.winner;
  const reason = board.game_over_reason;
  const byAssassin = reason === "assassin";
  const byKillerIntentional = reason === "killer_intentional";
  const youWon = winner === self.team;
  const color = winner === "red" ? "var(--red)" : "var(--blue)";

  const redWins = board.red_wins || 0;
  const blueWins = board.blue_wins || 0;

  const subtitle = byAssassin
    ? `El equipo ${winner === "red" ? "Rojo" : "Azul"} gana porque el rival contactó con el asesino.`
    : byKillerIntentional
    ? `¡El equipo ${winner === "red" ? "Rojo" : "Azul"} encontró todos sus agentes y atrapó al asesino!`
    : `El equipo ${winner === "red" ? "Rojo" : "Azul"} ha descubierto a todos sus agentes.`;

  return (
    <Dialog open={true}>
      <DialogContent data-testid="end-modal" className="bg-[color:var(--surface)] border-[color:var(--border)] text-white max-w-md" closeButton={false}>
        <DialogHeader>
          <DialogTitle className="font-heading text-4xl uppercase tracking-widest flex items-center gap-3" style={{ color }}>
            {byAssassin ? <Skull /> : <Crown />}
            {byAssassin ? "¡Asesino!" : byKillerIntentional ? "¡Captura final!" : "¡Victoria!"}
          </DialogTitle>
          <DialogDescription className="text-[color:var(--text-dim)] font-mono uppercase tracking-widest text-xs mt-2">
            {subtitle}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2 p-4 border border-[color:var(--border)] text-center">
          <div className="label-classified mb-1">Resultado</div>
          <div className="font-heading text-3xl uppercase" style={{ color }}>
            {youWon ? "HAS GANADO" : self.team ? "HAS PERDIDO" : "FIN DE LA PARTIDA"}
          </div>
        </div>
        <div className="mt-2 p-3 border border-[color:var(--border)] flex items-center justify-around">
          <div className="flex items-center gap-2">
            <Trophy size={16} className="text-red-500" />
            <span className="text-red-400 font-heading">ROJO</span>
            <span className="font-mono text-xl">{redWins}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-mono text-xl">{blueWins}</span>
            <span className="text-blue-400 font-heading">AZUL</span>
            <Trophy size={16} className="text-blue-500" />
          </div>
        </div>
        {onReset && (
          <button data-testid="btn-reset-game" className="btn-primary mt-4 w-full" onClick={onReset}>
            Nueva partida
          </button>
        )}
        {!onReset && (
          <div className="label-classified text-center mt-4">Esperando a que el anfitrión reinicie…</div>
        )}
        <button className="btn-ghost w-full mt-2" onClick={onLeave}>
          Salir al lobby
        </button>
      </DialogContent>
    </Dialog>
  );
}
